import { gql } from '@apollo/client';

export const DELETE_PRICING_SCHEME = gql`
  mutation DeletePricingScheme($pricingSchemeId: Long!) {
    deletePricingScheme(pricingSchemeId: $pricingSchemeId) {
      success
      message
      data
      messageKey
    }
  }
`;

export interface DeletePricingSchemeResponse {
  deletePricingScheme: { success: boolean; message: string; data?: string | null; messageKey?: string | null };
}

